import React from 'react';

const Table = ({ children, className, ...props }) => {
  return (<table className={`table-auto w-full border-separate border-spacing-0 ${className}`} {...props}>{children}</table>);
}

Table.Head = ({ children }) => {
  return (<thead className="sticky top-0 bg-white">{children}</thead>);
}

Table.Footer = ({ children }) => {
  return (<tfoot className="">{children}</tfoot>);
}

Table.Body = ({ children }) => {
  return (<tbody>{children}</tbody>);
}

Table.Row = ({ children, className, ...props }) => {
  return (<tr className={className} {...props}>{children}</tr>);
}

Table.Td = ({ children, className, ...props }) => {
  return (<td className={`border px-2 py-1 ${className}`} {...props}>{children}</td>);
}

Table.Th = ({ children, ...props }) => {
  return (<th className="border px-2 py-1 bg-white" {...props}>{children}</th>);
}

export default Table;
